import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button } from '../../components/Button'
import { CLOUDFRONT } from "gatsby-env-variables"
import HeaderTile from '../../components/HeaderTile'
import { Link, navigate } from "gatsby"
import { Loading } from "../../components/Loading"
import parse from 'html-react-parser'
import { useAPI } from '../../util/useAPI'
import { useWindowSize } from '../../util/useWindowSize'
import Seo from '../../components/seo'
import './../scss/Event.scss'
import { Script } from "gatsby"
import { ImageTile } from '../../components/ImageTile'
import { SlideShow } from '../../components/SlideShow'
import { useSelector } from "react-redux"
import { selectMyLocal } from "../../state/store"
/**
 * The /whatson/${event}/${location} template
 * 
 * @param {object} pageContext holds data passed from the build stage.
 * @returns a whats on event page based on the location in the url
 */
const Event = ({ pageContext }) => {
  let pathname = typeof window !== "undefined" ? window.location.pathname.split('/') : ""
  let cleanPath = typeof window !== "undefined" ? pathname.filter(e => e) : []
  const [isLoading, setIsLoading] = useState(true)
  const locationURL = typeof window !== "undefined" && cleanPath.length !== 0 ? (cleanPath[(cleanPath.length - 1)].replace('-', ' ')).replace('-', ' ') : 'global'
  const location = locationURL.replace(' ', '-').replace(' ', '-')
  const { status, data, error } = useAPI(`/v1/whatson/${pageContext.event.url}?location=${locationURL}`)
  const [itemError, setItemError] = useState(false)
  const size = useWindowSize()
  const [widget, setWidget] = useState(false)
  const [widgetLoading, setWidgetLoading] = useState(false)
  const [widgetStatus, setWidgetStatus] = useState('')
  const myLocal = useSelector(selectMyLocal)

  // format date from the detail date object
  const formatDate = (_dateString) => {
    const date = new Date(_dateString);
    const formatOption = {
      year: 'numeric',
      weekday: 'long',
      day: 'numeric',
      month: 'long',
    };
    const dateFormat = new Intl.DateTimeFormat('en-US', formatOption)
    const parts = dateFormat.formatToParts(date)
    const weekday = parts.find(part => part.type === 'weekday')?.value || ''
    const day = parts.find(part => part.type === 'day')?.value || ''
    const month = parts.find(part => part.type === 'month')?.value || ''
    const year = parts.find(part => part.type === 'year')?.value || ''
    return `${weekday} ${day} ${month} ${year}`
  }

  // format time data on the event detail page 
  const formatTime = (time) => {
    const [hour, minute] = time.split(':').map(Number)
    const period = hour >= 12 ? 'pm' : 'am'
    const hour12 = hour % 12 || 12
    return `${hour12}.${minute.toString().padStart(2, '0')}${period}`
  }

  /**
   * Handles api call loading and what to do once loaded. Error is used for when an item does not exist at the current location.
   */
  useEffect(() => {
    if (status === 'fetched') {
      setItemError(false)
      setTimeout(function () { setIsLoading(false) }, 0)
    } else if (status === 'error') {
      setItemError(true)
      setIsLoading(false)
    }
    if (status === 'fetching') {
      setIsLoading(true)
    }
  }, [status])

  /**
   * Callback function for order completion
   */
  const exampleCallback = function () {
    // Order complete
  }

  /**
   * 
   */
  if (typeof window !== "undefined" && data.length !== 0 && data.whatson.eventbrite === true) {
    // window.EBWidgets.createWidget({
    //   widgetType: "checkout",
    //   eventId: data.whatson.link,
    //   modal: true,
    //   modalTriggerElementId: `eventbrite-widget-trigger-${data.whatson.link}`,
    //   onOrderComplete: exampleCallback
    // })
    // window.EBWidgets.createWidget({
    //   widgetType: "checkout",
    //   eventId: "52766401728",
    //   iframeContainerId: `eventbrite-widget-trigger-${data.whatson.link}`,
    //   iframeContainerHeight: 425,
    //   onOrderComplete: exampleCallback
    // })
  }

  /**
   * Handles height changes on the eventbrite widget based on the current page.
   */
  useEffect(() => {
    const handler = event => {
      // const data = JSON.parse(event.data)
      if (event.data.messageName === "widgetRenderComplete") {
        setWidgetLoading(false)
      }
      if (event.data.messageName === "protectCheckout") {
        setWidgetStatus('checkout')
      } else if (typeof (event.data) === 'string' && event.data.includes('postrobot_hello')) {
        setWidgetStatus('checkout-large')
      } else {
        setWidgetStatus('')
      }
    }
    window.addEventListener("message", handler)
    return () => window.removeEventListener("message", handler)
  }, [])

  /**
   * Creates the eventbrite widget 
   */
  const buyTickets = (row) => {
    setWidgetLoading(true)
    window.EBWidgets.createWidget({
      widgetType: "checkout",
      eventId: row.eventbrite_id,
      iframeContainerId: `eventbrite-widget-trigger-${row.eventbrite_id}`,
      // iframeContainerHeight: 100,
      iFrameAutoAdapt: 100,
      onOrderComplete: exampleCallback
    })
    setWidget(true)
  }
  /**
   * handles if a link is opened in a new tab or not.
   * @param {object} button an object of the buttons details including if new tab or not and url
   */
  const openLink = (url, newTab) => {
    if (newTab === true) {
      window.open(url)
    } else {
      navigate(url.includes('whatson') ? url + myLocal.location.url : url.includes('menu') ? url + myLocal.location.url : url.includes('functions') ? url + myLocal.location.url : url)
    }
  }
  /**
   * Creates a row based on type, either text, image, iframe or slideshow
   * 
   * @param {object} row contains the current rows information
   * @returns a rendered row with the relevant information
   */
  const createRow = (row) => {
    switch (row.type) {
      case 'text':
        return (<div className='pagecontent__text' style={{ paddingBottom: row.gap + 'px' }}><div className={`whatson__text__${row.center === true ? 'center' : 'normal'} pagecontent__text__${row.full_width === true ? 'full' : 'small'}`}>
          {row.description && parse(row.description)}
          {row.button_name &&
            <Button text={row.button_name.toUpperCase()} onClickFunction={() => openLink(row.button_url, row.new_tab)} />
          }
        </div></div>)
      case 'image':
        return (
          <div style={{ paddingBottom: row.gap + 'px' }} >
            {row.heading ?
              <div className={`pagecontent__image__${row.full_width === true ? 'full' : 'short'}`}>
                <ImageTile title={row.heading} button={row.button_name ? true : false} text='More Info' alt={row.desktop_image.alt} image={{ "mobile": row.mobile_image.image, "desktop": row.desktop_image.image }} link={row.button_url} />
              </div>
              :
              <div style={{ height: row.height }} className={`pagecontent__image__${row.full_width === true ? 'full' : 'short'}`}>
                <ImageTile newWindow={row.new_window && row.new_window} alt={row.desktop_image.alt} title={row.heading} image={{ "mobile": row.mobile_image.image, "desktop": row.desktop_image.image }} />
              </div>
            }
          </div>
        )
      case 'eventbrite':
        return (<div style={{ paddingBottom: row.gap + 'px' }}>
          <>
            {widget === false ?
              <div className='event__content__button'>
                <button className='button__normal' type="button" onClick={() => buyTickets(row)}>{row.eventbrite_link}</button></div>
              : <></>
            }
            {widgetLoading && <div style={{ display: 'block' }}><div className="loader" style={{ position: 'static' }}></div></div>}
            <div className={`${widgetLoading === false ? 'eventbrite-widget' : ''} ${widgetStatus === "checkout" ? 'eventbrite-checkout' : widgetStatus === 'checkout-large' ? 'eventbrite-checkout-large' : ''}`} id={`eventbrite-widget-trigger-${row.eventbrite_id}`}></div>
          </>
        </div>)
      case 'slideshow':
        return <SlideShow autoplay={true} onChangeFunction={() => { }} images={row.slides.map((entry, key) => ({ link: null, mobile_image: { image: entry.mobile_image.image }, desktop_image: { image: entry.desktop_image.image } }))} />
      default:
        break;
    }
  }

  return (
    <div className='event__page'>
      <Script src="https://www.eventbrite.com/static/widgets/eb_widgets.js" />
      {/* <script src="https://www.eventbrite.com/static/widgets/eb_widgets.js"></script> */}
      <div onClick={() => (location.state && location.state.linkedFrom) === true ? navigate(-1) : navigate(`/whatson/${typeof window !== "undefined" && cleanPath.length !== 0 ? (cleanPath[(cleanPath.length - 1)]) : 'global'}`)} className='event__modalclose'><span className='closex bm-burger-bars'></span><span className='closex .bm-burger-bars'></span></div>
      {itemError &&
        <>
          <div className="menuitem__notfound">
            <HeaderTile alt='Event Not Found' image={{ mobile: `${CLOUDFRONT}/functions/Generic-77/functions-header-mobile`, desktop: `${CLOUDFRONT}/functions/Generic-77/functions-header-desktopv2` }} title={'Event Not Found'} />
            <div className='notfound menuitem__notfound'>
              <p>This event is not available at your selected location.</p>
              <p>Please go to the <Link to='/locations/'>Locations page</Link> and try a different location or visit your locals <Link to={`/whatson/${cleanPath[(cleanPath.length - 1)]}`}>Whats on page</Link></p>
            </div>
          </div>
        </>
      }
      <Seo title={pageContext.event?.seo_title} description={pageContext.event?.seo_meta_description} canonicalurl={pageContext.event?.seo_canonical_url} ogtitle={pageContext.event?.og_title} ogurl={pageContext.event?.og_url} ogdescription={pageContext.event?.og_description} ogimage={pageContext.event?.og_image && pageContext.event?.og_image.image} />
      {data.length !== 0 &&
        <>
          <Seo title={data.whatson.seo_title} description={data.whatson.seo_meta_description} canonicalurl={data.whatson.seo_canonical_url} ogtitle={data.whatson.og_title} ogurl={data.whatson.og_url} ogdescription={data.whatson.og_description} ogimage={data.whatson.og_image && data.whatson.og_image.image} />
          <div className="event__header">
            {size.width < 1050 &&
              <>
                {data.whatson.event_type === "opponents" ?
                  <>
                    <div className="event__header__block"></div>
                    {data.whatson.opponents.length === 2 ?
                      <div className="event__header__teams">
                        <img src={data.whatson.opponents[0].image.desktop_image.image} alt={data.whatson.opponents[0].image.desktop_image.alt} />
                        <img src={data.whatson.opponents[1].image.desktop_image.image} alt={data.whatson.opponents[1].image.desktop_image.alt} />
                      </div>
                      : <div className="event__header__team">
                        <img src={data.whatson.opponents[0].image.desktop_image.image} alt={data.whatson.opponents[0].image.desktop_image.alt} />
                      </div>
                    }
                  </>
                  : <div className="event__header__team">
                    <img src={data.whatson.image.mobile_image.image} alt={data.whatson.image.mobile_image.alt} />
                  </div>
                }
              </>
            }
            {size.width >= 1050 && data.whatson.event_type !== "opponents" &&
              <div className="event__header__banner">
                <img src={data.whatson.event_type === "opponents" ? data.whatson.image.banner_image.image : data.whatson.image.desktop_image.image} alt={data.whatson.event_type === "opponents" ? data.whatson.image.banner_image.alt : data.whatson.image.desktop_image.alt} />
              </div>
            }
          </div>
          <div className="event__content">
            {size.width >= 1050 ?
              <>
                {data.whatson.event_type === "opponents" ?
                  <>
                    <div className="event__header__block"></div>
                    {data.whatson.opponents.length === 2 ?
                      <div className="event__header__teams">
                        <img src={data.whatson.opponents[0].image.desktop_image.image} alt={data.whatson.opponents[0].image.desktop_image.alt} />
                        <img src={data.whatson.opponents[1].image.desktop_image.image} alt={data.whatson.opponents[1].image.desktop_image.alt} />
                      </div>
                      : <div className="event__header__team">
                        <img src={data.whatson.image.page_image.image} alt={data.whatson.image.page_image.alt} />
                      </div>
                    }
                  </>
                  : null
                }
                {data.whatson.event_type === "opponents" && data.whatson.opponents.length === 2 ?
                  <h1>{data.whatson.opponents[0].name} <span>vs</span> {data.whatson.opponents[1].name}</h1>
                  : <h1>{data.whatson.title}</h1>
                }
              </>
              : <>{
                data.whatson.event_type === "opponents" && data.whatson.opponents.length === 2 ?
                  <h1>{data.whatson.opponents[0].name} <span>vs</span> {data.whatson.opponents[1].name}</h1>
                  : <h1>{data.whatson.title}</h1>
              }</>
            }

            <div className='event__details__container'>
              {data.whatson.round !== null && <p className='event__content__type'>{data.whatson.round}</p>}
              {data.whatson.date !== null && <p className="event__content__date">{formatDate(data.whatson.date)}</p>}
              {data.whatson.time !== null && <p className="event__content__date">{data.whatson.all_day === true ? 'All Day' : formatTime(data.whatson.time)}</p>}
            </div>



            {data.whatson.blocks.map(row => createRow(row))}
          </div>
        </>
      }
      {isLoading === true &&
        <Loading />
      }
    </div>
  )
}

Event.propTypes = {
  pageContext: PropTypes.object
}

export default Event
